// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__9VQf9","topBottomGutter":"Layout_topBottomGutter__1n16K"};